import * as angular from 'angular';

import { Constants as constants } from '../../constants';
import { UsersRepo } from '../users/users.repo';
import { AddressListDialog } from './components/addressList.dialog';
import { EmailRepo } from './email.repo';
import { createEmail } from './views/createEmail';
import { emails } from './views/emails';


export const bulkEmailingModule = 'bulkEmailing';

angular
  .module(bulkEmailingModule, [])
  .constant("config", constants.Default)
  .service('usersRepo', UsersRepo)
  .service('emailRepo', EmailRepo)
  .component('emails', emails)
  .component('createEmail', createEmail)
  .component('addressListDialog', AddressListDialog)



// WEBPACK FOOTER //
// ./src/app/bulkemailing/bulkemailing.index.ts